/**
 * Authentication Service
 * API methods for customer authentication (OTP-based)
 */

import api from '../utils/api';

export const authService = {
  /**
   * Send OTP to mobile number
   * @param {string} mobileNumber - 10-digit mobile number
   * @returns {Promise} API response
   */
  sendOtp: (mobileNumber) => {
    return api.post('/customer/auth/send-otp', {
      mobileNumber
    });
  },

  /**
   * Verify OTP and login/register
   * @param {Object} data - Verification data
   * @param {string} data.mobileNumber - 10-digit mobile number
   * @param {string} data.otp - 6-digit OTP
   * @param {string} data.fullName - Full name (required for new users)
   * @param {string} data.email - Email (optional)
   * @returns {Promise} API response with token and customer data
   */
  verifyOtp: (data) => {
    return api.post('/customer/auth/verify-otp', data);
  },
};

export default authService;
